import { Component, OnDestroy } from '@angular/core'
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router'

import { Observable } from 'rxjs/Observable'

import { User } from '../../models/user.model'

import { MessagesDelegate } from '../../services/messages-delegate.service'
import { LoadingDelegate } from '../../services/loading-delegate.service'

import { UsersService } from '../../services/users.service'
import { EventsEmitterService } from '../../services/events-emitter.service'
import { AuthService } from '../../services/auth.service'

@Component({
  selector: 'ld-nav',
  template: require('./nav.component.html'),
  styles: [require('./nav.component.css')]
})
export class NavComponent implements OnDestroy {
  private showMenu = false
  private adminMenu: string
  private isEditing = false
  private user: User
  private startRoutingSub
  private endRoutingSub
  private editingSub
  private showMenuSub

  constructor (
    private usersService: UsersService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private messagesDelegate: MessagesDelegate,
    private eventsEmitterService: EventsEmitterService) {
    this.user = this.usersService.currentUser

    // reset flags when nav starts
    this.startRoutingSub = this.router.events
      .filter(ev => ev instanceof NavigationStart)
      .subscribe(() => {
        this.isEditing = false
        this.showMenu = false
      })

    // maj route data when nav end
    this.endRoutingSub = this.router.events
       .filter(ev => ev instanceof NavigationEnd)
       .subscribe(this.onRouting.bind(this))

    // listen to editing && is admin events
    this.showMenuSub = this.eventsEmitterService.subscribe('showAdminMenu', this.onShowMenu.bind(this))
    this.editingSub = this.eventsEmitterService.subscribe('editing', this.onEditing.bind(this))
  }

  ngOnDestroy () {
    this.endRoutingSub.unsubscribe()
    this.startRoutingSub.unsubscribe()
    this.editingSub.unsubscribe()
    this.showMenuSub.unsubscribe()
  }

  async logout () {
    try {
      await this.authService.logout()
      this.usersService.currentUser.reset()
      this.router.navigate(['/login'])
    } catch (e) {
      this.messagesDelegate.add('APP.LOGOUT.ERROR')
    }
  }

  emitEdit () {
    this.eventsEmitterService.emit('editing', !this.isEditing)
  }

  onRouting (event) {
    this.adminMenu = this.route.snapshot.firstChild
      ? this.route.snapshot.firstChild.data.adminMenu
      : ''
  }

  onEditing (label, editMode) {
    this.isEditing = editMode
  }

  onShowMenu (label, showMenu) {
    this.showMenu = showMenu
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/nav/nav.component.ts